import { useAuth } from '@/AuthProvider';
import { useRouter } from 'next/router';
import { PageWrapper } from '@zg-rentals/rental-revenue-components';
import { Box, Tabs, Text } from '@zillow/constellation-10';
import { tabbedPageConfig, type TabbedPageEnum } from './TabbedPage.config';
import { isTabActive } from './TabbedPage.utils';
import { useEffect } from 'react';
import { useAdManagementEliseAiApiHandler_hasEliseSfhEnabled } from '@zg-rentals/ts-ad-management-client-react-query';

export const TabbedPage = ({ tab }: { tab: TabbedPageEnum }) => {
  const router = useRouter();
  const { user } = useAuth();
  const { data: isEliseSfhEnabled } = useAdManagementEliseAiApiHandler_hasEliseSfhEnabled({});
  const activeTab = tab;

  const activeTabs = tabbedPageConfig.filter((config) => isTabActive(config, user, isEliseSfhEnabled));

  const activeTabConfig = activeTabs.find((config) => config.page === activeTab);

  useEffect(() => {
    if (!activeTabConfig || !activeTabConfig.pageVisitEvent) return;

    const { pageVisitEvent } = activeTabConfig;
    if (user) pageVisitEvent({ user });
  }, [activeTabConfig]);

  const onClickTab = (val: TabbedPageEnum) => {
    router.push(`/self-serve-data/${val}`);
  };

  useEffect(() => {
    if (activeTabs.length > 0 && !activeTabConfig) {
      router.replace(`/self-serve-data/${activeTabs[0].page}`);
    }
  }, [activeTabs, activeTabConfig, router]);

  if (activeTabs.length <= 0) return <Text css={{ padding: 'md' }}>Nothing to show here...</Text>;

  if (!activeTabConfig) return null;

  const { Component } = activeTabConfig;

  return (
    <PageWrapper title="Ad management">
      <Box css={{ padding: 'xs' }}>
        <Tabs.Root selected={activeTab} onSelectedChange={(val) => onClickTab(val as TabbedPageEnum)}>
          <Tabs.List>
            {activeTabs.map((config) => (
              <Tabs.Tab value={config.page} key={config.page}>
                {config.title}
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs.Root>

        <Box css={{ margin: '0 md' }}>
          <Box css={{ padding: 'md 0' }}>
            <Component />
          </Box>
        </Box>
      </Box>
    </PageWrapper>
  );
};
